import { newSpecPage } from '@stencil/core/testing'
import { CobaltProgressIndicator } from '../cobalt-progress-indicator'

describe('cobalt-progress-indicator', () => {
  it('should render progress indicator in bar format', async () => {
    const page = await newSpecPage({
      components: [CobaltProgressIndicator],
      html: '<cobalt-progress-indicator label="Label" progression="50"></cobalt-progress-indicator>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-progress-indicator class="cobalt-progress-indicator" label="Label" progression="50">
        <core-progress-indicator format="bar" label="Label" progression="50" size="medium"></core-progress-indicator>
      </cobalt-progress-indicator>
    `)
  })
  it('should render progress indicator in fractions format', async () => {
    const page = await newSpecPage({
      components: [CobaltProgressIndicator],
      html: '<cobalt-progress-indicator format="fractions" label="Label" total="5" current="1"></cobalt-progress-indicator>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-progress-indicator class="cobalt-progress-indicator" current="1" format="fractions" label="Label" total="5">
        <core-progress-indicator current="1" format="fractions" label="Label" size="medium" total="5"></core-progress-indicator>
      </cobalt-progress-indicator>
    `)
  })
})
